<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('stock_on_hand_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/onhand" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
                <i class="fa fa-print"></i>
                {{$t('print')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('branch')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.BranchId" @change="toList">
                                        <option value="">{{$t('branch')}}</option>
                                        <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead>
                            <tr>
                                <th>{{ $t('no') }}</th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('ItemCode')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('ItemName')">{{ $t('name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Category')">{{ $t('category') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('BranchName')">{{ $t('branch') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('BeginStock')">{{ $t('begin_stock') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('StockIn')">{{ $t('stock_in') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('StockOut')">{{ $t('stock_out') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Quantity')">{{ $t('end_stock') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Category}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td class="text-right">{{$number(ret.BeginStock, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.StockIn, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.StockOut, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.Quantity, '0,0.00')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            query: {
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                BranchId: '',
                SortType: '',
                SortField: ''
            },
            list: [],
            branches: []
        }
    },
    created(){
        this.branchList();
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('stockonhand', this.query).then(res => {
                if(this.$isValid(res)){
                    this.query.Total = res.data.Total;
                    this.list = res.data.Data;
                }
            }).finally(() => { loading.hide(); });
        },
        branchList(){
            var loading = this.$loading.show();
            this.$api().post('branch/list', { Limit: 0 }).then(res => {
                if(this.$isValid(res)){
                    this.branches = res.data.Data;
                }
            }).finally(() => { loading.hide(); });
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        },
        print() {
            let link = '/print/stock/onhand?';
            if(this.query.BranchId != '') link = link + 'branchid=' + this.query.BranchId;
            window.open(link, '_blank');
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        }
    }
}
</script>